import type { ReactNode } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/de';
import { LocalizedThemeProvider } from '../theme/LocalizedThemeProvider';
import { I18nProvider } from '../i18n/I18nProvider';

/**
 * Language, theme and date pickers — what every screen renders inside. Shared
 * by the app's root and the component tests, so the two cannot drift apart.
 *
 * I18nProvider owns the language; the theme localizes MUI's own component text
 * from it, so it has to sit inside. Date FORMAT is always German (DD.MM.YYYY)
 * whatever the UI language, so the picker locale is pinned to 'de' (see
 * utils/formatDate).
 */
export default function AppProviders({ children }: { children: ReactNode }) {
    return (
        <I18nProvider>
            <LocalizedThemeProvider>
                <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    adapterLocale="de"
                >
                    {children}
                </LocalizationProvider>
            </LocalizedThemeProvider>
        </I18nProvider>
    );
}
